export const REGEX = {
	BIC_REGEX: /^[A-z0-9]{8}$/,
	EMAIL_REGEX: /^[\w!#$%&'*+/=?`{|}~^-]+(?:\.[\w!#$%&'*+/=?`{|}~^-]+)*@(?:[A-z0-9-]+\.)+[A-z]{2,6}$/,
	IBAN_REGEX: /^[A-z]{2}[A-z0-9]{14}$/,
	PHONE_REGEX: /^(\+)?[0-9]{6,18}$/,
};
